import { render, staticRenderFns } from "./changeAccount.vue?vue&type=template&id=3225ceb8&scoped=true"
import script from "./changeAccount.vue?vue&type=script&lang=js"
export * from "./changeAccount.vue?vue&type=script&lang=js"
import style0 from "./changeAccount.vue?vue&type=style&index=0&id=3225ceb8&prod&lang=scss&scoped=true"
import style1 from "./changeAccount.vue?vue&type=style&index=1&id=3225ceb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225ceb8",
  null
  
)

export default component.exports